/* === CLAUDE 2026-10-01 #23 :: Panier latéral – ouverture, quantités, mise à jour === */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function drawer() { return document.getElementById('JpCart'); }
  function open() {
    var d = drawer(); if (!d) return;
    d.hidden = false; requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var p = d.querySelector('.jp-cart__panel'); if (p) p.focus();
  }
  function close() {
    var d = drawer(); if (!d) return;
    d.classList.remove('is-open'); document.documentElement.style.overflow = '';
    setTimeout(function () { d.hidden = true; }, 300);
  }
  function refresh(andOpen) {
    var d = drawer(); if (!d) return Promise.resolve();
    return fetch(ROOT + '?section_id=' + encodeURIComponent(d.dataset.sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('JpCart');
        if (fresh) { d.querySelector('.jp-cart__panel').innerHTML = fresh.querySelector('.jp-cart__panel').innerHTML; }
        var c = doc.querySelector('.jp-header__count');
        document.querySelectorAll('.jp-header__count').forEach(function (el) { el.textContent = c ? c.textContent : ''; el.hidden = !c || !c.textContent.trim() || c.textContent.trim() === '0'; });
        if (andOpen) open();
      });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-jp-cart-open]');
    if (o && drawer()) { e.preventDefault(); refresh(true); return; }
    if (e.target.closest('[data-jp-cart-close]')) { e.preventDefault(); close(); return; }
    var b = e.target.closest('[data-jp-line]');
    if (b) {
      e.preventDefault(); b.disabled = true;
      fetch(ROOT + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: parseInt(b.dataset.jpLine, 10), quantity: parseInt(b.dataset.jpQ, 10) }) })
        .then(function () { return refresh(false); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer() && !drawer().hidden) close(); });
  document.addEventListener('jp:cart:added', function () { refresh(true); });
})();
/* === /CLAUDE 2026-10-01 #23 === */
